// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__31i7e","name":"Header_name__1imGE","birthday":"Header_birthday__36Bxp","skeleton":"Header_skeleton__35m7P"};